import { MsalProvider, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Button, Textarea, useId } from "@fluentui/react-components";
import * as microsoftTeams from "@microsoft/teams-js";
import { Components, createDirectLine, createStore, hooks } from "botframework-webchat";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { clearArtifact, setArtifact, setArtifactLoading, setArtifactSession } from "artifactsSlice";
import { getVisibleArtifactVersion } from "components/artifacts/artifactViewState";
import { getThinking } from "components/thinking/thinkingState";
import { finishDeleteSkill, markPendingSkillSent, resetSkills, setSkillCatalog, syncActiveSkills } from "components/skills/skillsSlice";
import { forgetPendingSkill, resetSkillState, takeSkillChannelData } from "components/skills/skillsState";
import { resetChat } from "chatBotEventsSlice";
import ArtifactPanel from "components/artifacts/ArtifactPanel";
import { Feedback } from 'components/Feedback/Feedback';
import { clearLoadingPhrase, setLoadingPhrase } from "loadingPhraseSlice";
import { hide, show } from "components/Home/homeVisibilitySlice";
import { GuidePrompts } from "components/Prompts/Guide/GuidePrompts";
import { GuidePromptsSearcher } from 'components/Prompts/Guide/GuidePromptsSearcher/GuidePromptsSearcher';
import { Tips } from "components/Prompts/Tips/Tips";
import { ModalType } from 'constants/enums';
import { IModalValue } from 'interfaces/IModalValue';
import { Modal } from "shared/components/Modal/Modal";
import { openOrCloseModal } from 'shared/components/Modal/modalActionsSlice';
import { SideNav } from "shared/components/SideNav/SideNav";
import { userSendPrompt } from 'shared/components/SideNav/userSendPromptSlicer';
import { Toolbar } from "shared/components/Toolbar/Toolbar";
import { setAppJwt } from 'shared/functions/appJwt';
import { storeMessageReaction, storeProvideFeedback } from 'shared/functions/createFeedbackHistory';

import LoadingPhraseIndicator from "./components/webChat/LoadingPhraseIndicator";
import WebChat from "./components/webChat/webChat";
import { toggleSideNav } from './shared/components/SideNav/SideNavToggleButton/toggleSideNav';
import activityMiddleware from "./shared/functions/activityMiddleware"
import api from "./shared/functions/api"
import chatBotStyles from "./shared/functions/chatBotStyles"
import { setWebChatDispatch } from "./shared/functions/webChatStore"

import "./App.css";

// Mantiene los tres puntitos del typing y les agrega la frase de
// "Cargando..." del loop agéntico (ver LoadingPhraseIndicator).
const typingIndicatorMiddleware = () => (next: any) => (args: any) => (
  <LoadingPhraseIndicator defaultIndicator={next(args)} />
);

function App() {
  try{
    microsoftTeams.app.initialize().catch((error)=>{console.log("Not in teams")});
  } catch(err){
    console.log("Not in teams")
  }
  const effectRan = useRef(false);
  const isAuthenticated = useIsAuthenticated();
  let currentCode = false;
  let botToken = '';
  let jwt = '';
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const code = urlParams.get('code');
  let token = '';
  const { instance } = useMsal();

  let dispatch = useDispatch();



  const [firstChat, setFirstChat] = useState<boolean>(true);
  const [tokenToFeedback, setTokenToFeedback] = useState<string>('');
  const inputId = useId("input");
  const [session, setSession] = useState<
    | false
    | Readonly<{
        directLine: ReturnType<typeof createDirectLine>;
        key: number;
        store: ReturnType<typeof createStore>;
      }>
  >();

  // Function to set an item in session storage with TTL
  function setSessionStorageItem(key: any, value: any, ttl: any) {
    const now = new Date();

    // Create an object that stores the value and the expiration time
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };

    // Save the item in session storage
    sessionStorage.setItem(key, JSON.stringify(item));
  }

  // Function to get an item from session storage
  function getSessionStorageItem(key: any) {
    const itemStr = sessionStorage.getItem(key);

    // If the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    // If the item is expired, remove it from session storage and return null
    if (now.getTime() > item.expiry) {
      sessionStorage.removeItem(key);
      return null;
    }

    return item.value;
  }

  let homeVisibility = useSelector((state: any) => state.homeVisibility.value);
  let cardText = useSelector((state: any) => state.cardText.value);
  let chatBotEvent = useSelector((state: any) => state.chatBotEvents.value);
  let modal = useSelector((state: any) => state.modalActions.value);

  const getToken = async () => {
    const accounts = instance.getAllAccounts();
    let teamsapp;
    let loginResponse;
    //console.log(queryString);
    let teams = false;
    try {
      teamsapp = await microsoftTeams.app.initialize();
      teamsapp;
      teams = true;
    } catch(err) {
      teams = false;
    }

    if(!code) {
      try {
        if(teams) {
          const accounts = instance.getAllAccounts();
          const request = {
            account: accounts[0],
            scopes: ["User.Read"],
          };

          token = await microsoftTeams.authentication.getAuthToken({});
          jwt = await api.fetchTokenFromTeams(token)
          setAppJwt(jwt)
          console.log('JWT:', jwt);
          //console.log('Fetching token from AAD', {code: code, botToken});
          //botToken = await api.fetchConversationHistory("HkyJC1Ty5nRBXpvKECY1RT-us", JSON.parse(botToken).conversationId);
          botToken = await api.fetchToken(jwt)
          console.log('Login successful:', botToken);
        } else {
          console.log('Login redirect');
          location.href = '/.auth/login/aad/callback';
          //loginResponse = await instance.loginRedirect();
        }
      } catch (error) {
        console.error('Login error:', error);
      }
    } else if(code) {
        try{
          jwt = await api.fetchTokenFromAAD(code || '');
          
        }catch(error){
          location.href = '/.auth/login/aad/callback';
        }
        setAppJwt(jwt)
        console.log('JWT:', jwt);
        // Si el login se originó en un enlace de artifact compartido
        // (/artifact/<id> guarda postLoginRedirect antes de mandar al
        // login de Entra ID), regresa a esa página ya con sesión.
        const postLoginRedirect = localStorage.getItem('postLoginRedirect');
        if (postLoginRedirect) {
          localStorage.removeItem('postLoginRedirect');
          location.href = postLoginRedirect;
          return botToken;
        }
        //console.log('Fetching token from AAD', {code: code, botToken});
        //botToken = await api.fetchConversationHistory("HkyJC1Ty5nRBXpvKECY1RT-us", JSON.parse(botToken).conversationId);
        botToken = await api.fetchToken(jwt)
        // botToken = await api.fetchConversationHistory("59Aymd1nM0I8Nqg9AXcLt0-us", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiam9zZW0ubWFjaWFzbUBleHQuY2VtZXguY29tIn0.QI5i74Zmj6K2YtLDNhrl3svAyDOzvkmDBPyJmKDY694");
        console.log('Login successful:', botToken);
    }
    return botToken
  }

  const initConversation = useCallback(async (token: any) => {
    //setSession(false);
    //await instance.initialize();
    //await instance.handleRedirectPromise();
    //microsoftTeams.authentication.getAuthToken({})

    dispatch(toggleSideNav(false));

    if(token){
      // token = JSON.parse(botToken || '{}').token
      token = token.token
    }

    // dispatch de Redux de la app: dentro del store middleware de Web
    // Chat el nombre "dispatch" queda sombreado por el del store de
    // Web Chat, así que se captura aquí con otro nombre.
    const appDispatch = dispatch;

    // Una conversación nueva no hereda el artifact de la anterior.
    appDispatch(clearArtifact());
    // Ni sus skills: los chips se vacían y, si es un resume, el
    // historial inyectado los vuelve a sincronizar (activeSkills).
    appDispatch(resetSkills());
    resetSkillState();

    const key = Date.now();
    setTokenToFeedback(token)
    localStorage.setItem('token', token)
    if(session && session.directLine){
      session.directLine.end()
    }
    setSession({
      directLine: createDirectLine({ token }),
      key,
      store:createStore({}, ({ dispatch }: any) => next => action => {
        console.log(action)

        // Guarda el dispatch del store de Web Chat para poder
        // inyectar actividades locales en el transcript (log SQL de
        // debug) sin pasar por Direct Line ni por el bot.
        setWebChatDispatch(dispatch);

        // Al abrir una conversación del panel, SideNav deja en
        // localStorage el id de la sesión original; en cuanto la
        // conexión Direct Line queda lista se avisa al bot con un
        // evento para que retome esa sesión (contexto + guardado)
        // en lugar de empezar una conversación sin memoria.
        if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
          // Catálogo de skills del bot para el menú "/" del chat: el
          // bot responde con el event "luca/skills" (ver abajo).
          dispatch({
            type: 'WEB_CHAT/SEND_EVENT',
            payload: { name: 'luca/listSkills', value: {} }
          });
          const resumeSessionId = localStorage.getItem('resumeSessionId');
          if (resumeSessionId) {
            localStorage.removeItem('resumeSessionId');
            dispatch({
              type: 'WEB_CHAT/SEND_EVENT',
              payload: { name: 'luca/resumeConversation', value: { sessionId: resumeSessionId } }
            });
            // El panel de artifacts conoce la sesión retomada: lista
            // sus versiones y, por si había una generación en curso al
            // salir, abre una ventana de polling hasta que aparezca.
            // Si la conversación se abrió desde la biblioteca de
            // artifacts (sección Artifacts del SideNav), openArtifactId
            // dice qué versión quiere ver el usuario: esa se abre en el
            // panel en vez de sólo restaurar la última.
            const openArtifactId = localStorage.getItem('openArtifactId') || '';
            const openArtifactSession = localStorage.getItem('openArtifactSession') || '';
            localStorage.removeItem('openArtifactId');
            localStorage.removeItem('openArtifactSession');
            appDispatch(setArtifactSession({
              sessionId: resumeSessionId,
              // Sólo si la elección es de ESTA conversación (un resume
              // que no llegó a conectar pudo dejar el id colgado).
              preferredArtifactId:
                openArtifactSession === resumeSessionId ? openArtifactId : '',
            }));
          }
        }

        // Cada mensaje del usuario lleva como hint qué versión del
        // artifact está viendo en el panel (channelData): el backend
        // la usa para resolver "a esta cámbiale..." al elegir la
        // versión base de una modificación.
        // También viajan las skills del menú "/": la elegida (skill)
        // y las que el usuario quitó del área de texto (dropSkills).
        if (action.type === 'DIRECT_LINE/POST_ACTIVITY' && action.payload?.activity?.type === 'message') {
          const visibleArtifactVersion = getVisibleArtifactVersion();
          const thinking = getThinking();
          const skillData = takeSkillChannelData();
          if (skillData.skill) {
            appDispatch(markPendingSkillSent());
          }
          if (visibleArtifactVersion != null || thinking != null || skillData.skill || skillData.dropSkills) {
            action = {
              ...action,
              payload: {
                ...action.payload,
                activity: {
                  ...action.payload.activity,
                  channelData: {
                    ...(action.payload.activity.channelData || {}),
                    ...(visibleArtifactVersion != null ? { visibleArtifactVersion } : {}),
                    ...(thinking != null ? { thinking } : {}),
                    ...skillData,
                  },
                },
              },
            };
          }
        }

        if (action.type === 'DIRECT_LINE/QUEUE_INCOMING_ACTIVITY' || action.type === 'DIRECT_LINE/INCOMING_ACTIVITY') {

          // Frase de "Cargando..." del loop agéntico: el bot la manda
          // como event activity en cada paso y se muestra junto al
          // typing indicator (LoadingPhraseIndicator).
          if (action.payload.activity.type === 'event' && action.payload.activity.name === 'luca/progress') {
            appDispatch(setLoadingPhrase(action.payload.activity.value?.phrase || ''));
            // En cuanto el loop empieza a generar el artifact, se abre
            // el panel con la animación de skeleton para que el usuario
            // vea dónde va a aparecer. El evento luca/artifact (con o
            // sin html) la cierra después.
            if (action.payload.activity.value?.step === 'create_artifact') {
              appDispatch(setArtifactLoading());
            }
          }

          // Artifact interactivo (tool create_artifact del bot): llega
          // como event activity tras la respuesta final y se renderiza
          // en el panel lateral (ArtifactPanel, iframe sandboxed).
          if (action.payload.activity.type === 'event' && action.payload.activity.name === 'luca/artifact') {
            appDispatch(setArtifact(action.payload.activity.value || {}));
          }

          // Catálogo de skills (respuesta a luca/listSkills y a
          // luca/deleteSkill; en ese caso trae "deleted" con el resultado).
          if (action.payload.activity.type === 'event' && action.payload.activity.name === 'luca/skills') {
            appDispatch(setSkillCatalog(action.payload.activity.value?.skills || []));
            const deleted = action.payload.activity.value?.deleted;
            if (deleted?.name) {
              if (deleted.ok) forgetPendingSkill(deleted.name);
              appDispatch(finishDeleteSkill(deleted));
            }
          }

          // Cada respuesta del bot dice qué skills siguen activas: los
          // chips azules del área de texto se sincronizan con eso (el
          // bot pudo soltar la skill porque el usuario cambió de tema).
          if (
            action.payload.activity.type === 'message' &&
            action.payload.activity.from?.role === 'bot' &&
            Array.isArray(action.payload.activity.channelData?.activeSkills)
          ) {
            appDispatch(syncActiveSkills(action.payload.activity.channelData.activeSkills));
          }

          // Cualquier mensaje nuevo (la respuesta del bot o el eco del
          // mensaje del usuario) cierra la frase de "Cargando...".
          if (action.payload.activity.type === 'message') {
            appDispatch(clearLoadingPhrase());
          }

          // Get reaction message id
          if (action.payload.activity.type === 'messageReaction') {
            if (+action.payload.activity.reactionsAdded.length >= 1) {
              storeMessageReaction(action);
            }
          }

          // Get provide feedback id by message
          if (action.payload.activity.type === 'message') {
            if (action.payload.activity.attachments && +action.payload.activity.attachments.length >= 1) {
              if (action.payload.activity.attachments[0].content) {
                if (action.payload.activity.attachments[0].content.actions) {
                  if (action.payload.activity.attachments[0].content.actions[0].title === 'Provide feedback') {
                    storeProvideFeedback(action);
                  }
                }
              }
            }
          }
        }


        if (action.type === 'DIRECT_LINE/POST_ACTIVITY' && action.payload && action.payload.activity && action.payload.activity.value && action.payload.activity.value.message && !action.payload.activity.text && action.payload.activity.value.action == "send_feedback_to_bot") {
        
          console.log('Message dropped:', action);
          dispatch({ type: 'WEB_CHAT/SEND_MESSAGE_BACK', payload: {text: action.payload.activity.value.message, value: action.payload.activity.value}}); 
          return;

        }
        
        return next(action);
      }),
    });

}, [setSession]);


  const onCloseModal = (value: IModalValue) => {
    dispatch(openOrCloseModal(value))
  }

  
  useEffect(() => {
    const newToken = localStorage.getItem('newToken') || '';
    dispatch(userSendPrompt('New chat'))

    if (!effectRan.current) {
      console.log("effect applied - only on the FIRST mount");
      // F5 / primera carga: siempre arranca con una conversación
      // vacía. Se limpian restos de la sesión anterior para no
      // retomar nada por accidente; la última conversación se puede
      // recuperar con el botón "Load last conversation".
      localStorage.removeItem('newToken');
      localStorage.removeItem('resumeSessionId');
      localStorage.removeItem('openArtifactId');
      localStorage.removeItem('openArtifactSession');
      getToken().then((botToken) => {
        initConversation(botToken);
      });
    } else if(newToken !== ''){
      localStorage.removeItem('newToken')
      initConversation(JSON.parse(newToken));
      dispatch(resetChat(false));
      
    }
    return () => {
      effectRan.current = true;
    }
  }, [chatBotEvent]);

    
  return (<>
    <Toolbar />
    <div className="layout">
      <SideNav />
      <main className="main-content">
          {!!(session && session.directLine) && (
            <Components.Composer
              styleOptions={chatBotStyles}
              directLine={session.directLine}
              key={session.key}
              store={session.store}
              activityMiddleware={activityMiddleware}
              typingIndicatorMiddleware={typingIndicatorMiddleware}
            >
              <WebChat cardText={cardText} homeVisibility={homeVisibility} />
              {modal.isOpen && modal.modalType === ModalType.Prompts && (
                <Modal 
                  title="Prompts Guide for LUCA Bot." 
                  size={'70rem'} 
                  onClose={() => onCloseModal({ isOpen: false, modalType: ModalType.Prompts })} 
                  extraChildren={<GuidePromptsSearcher />}
                >
                  <GuidePrompts onClose={() => onCloseModal({ isOpen: false, modalType: ModalType.Prompts })} />
                  <hr className="line" />
                  <Tips />
                </Modal>
              )}
              {
                modal.isOpen && modal.modalType === ModalType.Feedback &&(
                  <Modal 
                    title="We ask you to provide feedback" 
                    size={'702px'} 
                    onClose={() => onCloseModal({ isOpen: false, modalType: ModalType.Feedback })}
                  >
                    <Feedback token={tokenToFeedback}/>
                  </Modal>
                )
              }
            </Components.Composer>
          )}
        </main>
        <ArtifactPanel />

    </div>
  </>)
}

export default memo(App);
